import React, { useEffect, useState, useMemo } from "react";
import { Select, Button, message, Card, Divider, Tooltip } from "antd";

const AuditExport = ({ startDate, endDate }) => {
  const [auditors, setAuditors] = useState([]);
  const [selectedAuditors, setSelectedAuditors] = useState([]);
  const [loading, setLoading] = useState(false);

  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    fetch(`${apiUrl}/api/auditor/getAuditAdmins`)
      .then((res) => res.json())
      .then((data) => {
        if (data?.success) setAuditors(data.data);
      })
      .catch(() => message.error("Failed to load auditors"));
  }, []);

  // ✅ ENABLE / DISABLE LOGIC
  const isButtonEnabled = useMemo(() => {
    return (
      Boolean(startDate) &&
      Boolean(endDate) &&
      selectedAuditors.length > 0 &&
      !loading
    );
  }, [startDate, endDate, selectedAuditors, loading]);

  const handleGenerateAudit = async () => {
    if (!isButtonEnabled) return;

    try {
      setLoading(true);

      const response = await fetch(
        `${apiUrl}/api/auditor/exportAuditsByAuditors`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            auditorIds: selectedAuditors,
            startDate,
            endDate,
          }),
        }
      );

      if (!response.ok) throw new Error();

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = `Audit_Report_${startDate}_to_${endDate}.xlsx`;
      document.body.appendChild(a);
      a.click();

      a.remove();
      window.URL.revokeObjectURL(url);

      message.success("Audit report downloaded successfully");
    } catch {
      message.error("Failed to generate audit report");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className="shadow-md mb-4">
      <h3 className="text-xl font-medium mb-4">
        Generate Audit Report
      </h3>
      <Divider />

      <div className="flex justify-between items-center">
        <Select
          mode="multiple"
          allowClear
          placeholder="Select auditors"
          className="w-72"
          onChange={setSelectedAuditors}
          options={auditors.map((a) => ({
            label: a.userName,
            value: a._id,
          }))}
        />

        {/* ✅ ALWAYS VISIBLE, CONDITIONALLY ENABLED */}
        <Tooltip
          title={
            isButtonEnabled
              ? "Generate audit report"
              : "Select date range and auditors to enable"
          }
        >
          <Button
            type="primary"
            loading={loading}
            disabled={!isButtonEnabled}
            onClick={handleGenerateAudit}
          >
            Generate Audit Report
          </Button>
        </Tooltip>
      </div>
    </Card>
  );
};

export default AuditExport;
